import { ComplexRoute } from 'router/components/Routes/Routes';
import Vehicles from './pages/Vehicles';
import Vehicle from './pages/Vehicle';

export default [
  {
    index: true,
    element: Vehicles,
    label: 'vehicles',
  },
  {
    path: ':id',
    element: Vehicle,
  },
] as Array<ComplexRoute>;
